import React from 'react'
import { safeHTML } from '../../../../utils/safeHTML'
import { useTranslation } from '../../../../translations'
import Toggle from '../../../baseComponents/gui/toggle/Toggle'
import SetsInfo from '../setsInfo/SetsInfo'

const SetsHeader = React.forwardRef(
  (
    { title, activeTab, toggleData, toggleSetter, button, gradeData, activeCash, showTabs },
    ref,
  ) => {
    const { t } = useTranslation()

    const tabComponent = showTabs ? (
      <Toggle
        className={'sets__toggle'}
        {...toggleData}
        funcs={toggleSetter}
        startActive={activeTab}
      />
    ) : null

    const buttonData = (() => {
      // TODO: костыль - переделать после релиза
      if (activeCash === null || activeCash === undefined) return true

      return button
    })()

    return (
      <>
        <h2 className={'sets__title'}>{safeHTML(t(title))}</h2>

        <SetsInfo
          gradeData={gradeData}
          activeCash={activeCash}
          button={buttonData}
        />

        {tabComponent}
      </>
    )
  },
)
export default SetsHeader
SetsHeader.displayName = 'SetsHeader'
SetsHeader.propTypes = {}
